<template>
  <div>
    <router-view />
  </div>
</template>

<style>
body {
  position: relative;
  margin: 0;
  font-size: 16px;
  height: 100vh;
  height: 100dvh;
  overflow-y: hidden;
  --brick: #BD482D;
  --blue: #5E7FC9;
  --indigo: #1A1F37;
  --white: #FFFFFF;
  --sandstone: #E6DCD2;
  --grey: #808080;
  --light-charcoal: #373737;
  --charcoal: #191919;
  background: var(--charcoal); 
  color: var(--sandstone);
}
#app{
  height: 100vh;
  height: 100dvh;
  overflow-y: hidden;
}

.contentHeight{
  height:calc(100vh - 4em - 2px);
  height:calc(100dvh - 4em - 2px);
}
@font-face {
  font-family: "DinCondensed";
  src: url(assets/fonts/DinCondensedBold.woff2) format("woff2");
}
@font-face {
  font-family: "DDin";
  src: url(assets/fonts/DDinBold.woff2) format("woff2");
}
h1 {
  font-family: "DinCondensed", sans-serif;
  font-size: 2.2em;
  font-weight: normal;
  padding: 0.3em 0 0 0;
  line-height: 1em;
}
h2 {
  font-family: "DinCondensed", sans-serif;
  font-size: 1.8em;
  font-weight: normal;
  padding: 0.3em 0 0 0;
  line-height: 1em;
}
h3 {
  font-family: "DDin", sans-serif;
  font-size: 1.8em;
  font-weight: normal;
  padding: 0.2em 0 0 0;
  line-height: 1em;
}
p {
  font-family: "DDin", sans-serif;
  font-size: 1em;
  font-weight: normal;
  line-height: 1.2em;
}
a {
  text-decoration: none;
  color: var(--white);
}
button {
  color: var(--charcoal);
  background-color: var(--sandstone);
  border: none;
  border-radius: 0.25em;
  transition: 0.1s;
  h2 {
    margin: 0.1em 0.5em;
  }
  cursor: pointer;
   user-select: none; 
}
button:hover {
  color: var(--sandstone);
  background-color: var(--brick);
}
</style>